import * as yup from "yup";

export const validationSchema = yup.object({
  email: yup
    .string()
    .email("O Email digitado é invalido.")
    .required("O email é obrigatório"),
  nome: yup.string().required("O nome é obrigatório"),
  sobrenome: yup.string().required("O sobrenome é obrigatório."),
  descricao: yup.string().required("A descricao é obrigatória."),
  redeSocial: yup
    .string()
    .required("Selecionar uma rede social é obrigatório."),
  linguagemProgramacaoSimples: yup
    .string()
    .required("Selecionar uma linguagem de programacao é obrigatório."),
  linguagemProgramacao: yup
    .string()
    .required("Selecionar uma linguagem de programacao é obrigatório."),
  multiplaSelecao: yup
    .array()
    .min(1, "Selecionar uma ou mais linguagem de programacao é obrigatório."),
});
